import axios, { AxiosResponse } from 'axios';

import { NotificationDetail } from 'directory/listings/notification-modals/types';

export const getNotification = async (tenantId: number, notificationId: string): Promise<NotificationDetail> => {
    const { data }: AxiosResponse<NotificationDetail> = await axios.get(
        `/api/tenants/${tenantId}/notifications/${notificationId}`,
    );

    return data;
};
